<div class="change-password-dialog">
    <div class="dialog-header flex items-center justify-between">
        <h2 mat-dialog-title class="text-xl font-semibold text-primary">
            {{
                isCreatePassword()
                    ? ('filmMakerSignIn.Create Password' | translate)
                    : ('filmMakerSignIn.Change Password' | translate)
            }}
        </h2>
        <button
            mat-icon-button
            (click)="onCancel()"
            class="hover:text-primary-dark text-primary"
            [attr.aria-label]="'Close'"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="dialog-content">
        <p class="mb-4 text-sm text-gray-600 dark:text-gray-400">
            {{
                isCreatePassword()
                    ? ('filmMakerSignIn.Verify your identity to create your password'
                      | translate)
                    : ('filmMakerSignIn.Verify your identity to change your password'
                      | translate)
            }}
        </p>

        <!-- Email OTP Field (for non-Indian users) -->
        @if (!isIndian) {
            <div>
                <app-email-otp-field
                    [label]="'filmMakerSignIn.Email' | translate"
                    [emailControl]="emailControl"
                    [otpControl]="emailOtpControl"
                    [type]="otpType"
                    [type]="otpType"
                    [required]="true"
                    [disabled]="true"
                    [isViewMode]="false"
                    [isAdminMode]="true"
                    [isProfileMode]="false"
                    [showVerificationCheckbox]="false"
                    (sendOtp)="onEmailOtpSent($event)"
                    (verificationStatusChange)="
                        onEmailVerificationStatusChange($event)
                    "
                ></app-email-otp-field>
            </div>
        }

        <!-- Phone OTP Field (for Indian users) -->
        @if (isIndian) {
            <div>
                <app-phone-otp-field
                    [label]="'filmMakerSignIn.Mobile number' | translate"
                    [phoneControl]="phoneControl"
                    [countryCodeControl]="countryCodeControl"
                    [isoCountryCodeControl]="isoCountryCodeControl"
                    [otpControl]="phoneOtpControl"
                    [required]="true"
                    [disabled]="false"
                    [type]="otpType"
                    [isViewMode]="false"
                    [isAdminMode]="true"
                    [isProfileMode]="false"
                    [showVerificationCheckbox]="false"
                    [isVerified]="false"
                    [isWaNumber]="isWaNumber()"
                    (sendOtp)="onPhoneOtpSent($event)"
                    (verificationStatusChange)="
                        onPhoneVerificationStatusChange($event)
                    "
                    (waNumberChange)="onWaNumberChange($event)"
                    [type]="otpType"
                ></app-phone-otp-field>
            </div>
        }
    </mat-dialog-content>

    <mat-dialog-actions
        class="dialog-actions flex items-center justify-end gap-3"
    >
        <button
            mat-button
            (click)="onCancel()"
            [disabled]="isProcessing()"
            class="text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200"
        >
            {{ 'filmMakerSignIn.Cancel' | translate }}
        </button>

        <!-- Continue Button (shown after OTP is verified) -->
        @if (isOtpVerified()) {
            <button
                mat-flat-button
                [color]="'primary'"
                (click)="onContinue()"
                [disabled]="isProcessing()"
            >
                <span>{{ 'filmMakerSignIn.Continue' | translate }}</span>
            </button>
        }
    </mat-dialog-actions>
</div>
